import React from "react";
import { Container, Row, Col } from "reactstrap";
import CardSection from "../../components/Card/Card";
import useApi from "../../hooks/useApi";
import qs from "query-string";
// import river from '../assets/mountains.png'

import styles from "./ResourceStack.module.scss";

const organiseCards = (cardArray, cardLimit = 8) => {
  const cardObject = { topCards: [], sideCards: [], bottomCards: [] };
  cardArray.forEach((card, index) => {
    if (index >= cardLimit) {
      return;
    } else {
      if (index < 4) {
        cardObject.topCards.push(card);
      } else if (index < 8) {
        cardObject.sideCards.push(card);
      } else {
        cardObject.bottomCards.push(card);
      }
    }
  });
  return cardObject;
};

export const ResourceStack = (props) => {
  const { headline, showTopCards, featuredPublicationPosition = 'left' } = props;
  const filterQueryString = qs.stringify({ limit: 9 }, { arrayFormat: "bracket" });

  // Get posts from API
  const manuallySelect = props.publications && props.publications.length
  const [{ data = {}, loading }] = useApi(`get/publications?${filterQueryString}`, { manual: manuallySelect });
  const publications = (manuallySelect ? props.publications : data.publications) || []
  const [firstPublication, ...rest] = publications;
  const featuredPublication = props.featuredPublication || firstPublication;

  if (!publications.length) return null;

  const organisedCards = organiseCards(props.featuredPublication ? publications : rest, props.cardLimit);
  // console.log('publications', publications.length)
  // console.log('organisedCards', organisedCards)

  return (
    <Container className={styles.container} style={props.style}>
      <Row className="pl-0">
        <Col md={12} className="px-1">
          <h3>{headline}</h3>
        </Col>
      </Row>
      {loading && !manuallySelect ? (
        "Loading"
      ) : (
        <>
          {showTopCards ? <Row className="pl-1">
            <Col md="12">
              <Row className="h-100">
                {organisedCards.topCards.map((content, index) => (
                  <Col
                    key={index}
                    xs={12}
                    md={3}
                    className={`pr-1 pl-0 ${content.text || content.image ? (content.text ? "pt-0 pb-0" : "pt-1 pb-0") : "pt-1"
                      }`}
                  >
                    <CardSection data={content} cardImage={false} />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row> : null}
          <Row className="pl-1">
            {featuredPublicationPosition !== 'right'
              ? <Col md="6" className="pt-1 pr-1 pl-0">
                <CardSection data={featuredPublication} cardImage={true} />
              </Col>
              : null}
            <Col md="6">
              <Row className="h-100">
                {organisedCards.sideCards.map((content, index) => (
                  <Col
                    key={index}
                    xs={12}
                    md={content.text || content.image ? 6 : 6}
                    className={`pr-1 pl-0 ${content.text || content.image ? (content.text ? "pt-0 pb-0" : "pt-1 pb-0") : "pt-1"
                      }`}
                  >
                    <CardSection data={content} cardImage={false} />
                  </Col>
                ))}
              </Row>
            </Col>
            {featuredPublicationPosition === 'right'
              ? <Col md="6" className="pt-1 pr-1 pl-0">
                <CardSection data={featuredPublication} cardImage={true} />
              </Col>
              : null}
          </Row>
          <Row className="pl-1">
            <Col md="12">
              <Row className="h-100">
                {[...(!showTopCards ? organisedCards.topCards : []), ...organisedCards.bottomCards].map((content, index) => (
                  <Col
                    key={index}
                    xs={12}
                    md={3}
                    className={`pr-1 pl-0 ${content.text || content.image ? (content.text ? "pt-0 pb-0" : "pt-1 pb-0") : "pt-1"
                      }`}
                  >
                    <CardSection data={content} cardImage={false} />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default ResourceStack;
